import { render, staticRenderFns } from "./LogEvents.vue?vue&type=template&id=5225ffb9"
import script from "./LogEvents.vue?vue&type=script&lang=js"
export * from "./LogEvents.vue?vue&type=script&lang=js"
import style0 from "./LogEvents.vue?vue&type=style&index=0&id=5225ffb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports